import getAuthorization from "./getAuthorization";
import { getScopesFromToken } from "./getScopesFromToken";
import { LoginScope } from "../generated/graphql";

export function hasScopeFromToken(token: string, requestedScope: LoginScope) {
  const scopes = getScopesFromToken(token);
  return scopes?.includes(requestedScope);
}

export function hasScopeFromContext(ctx, requestedScope: string) {
  const authorization = getAuthorization(ctx);
  return authorization.scope?.includes(requestedScope);
}
